import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Subscription } from 'rxjs';
import { Recommendation } from 'src/app/modules/course-acc-inspection-report/models/recommendation';
import { Furniture } from 'src/app/modules/stp-registration/models/furniture.model';
import { StpManagement } from 'src/app/modules/stp-registration/models/stp-management.model';
import { StpOccupationTool } from 'src/app/modules/stp-registration/models/stp-occupation-tool.model';
import { StpTrainer } from 'src/app/modules/stp-registration/models/stp-trainer.model';
import { StpRegistrationStorageService } from 'src/app/modules/stp-registration/services/stp-registration-storage.service';
import { StpRegistrationService } from 'src/app/modules/stp-registration/services/stp-registration.service';
import { environment } from 'src/environments/environment';
import { fileDeleteRequest } from 'src/app/modules/course-acc-inspection-report/DTO/fileDeleteRequest';
import { Location } from '@angular/common';
import { StpSacScrutinyResultDto } from 'src/app/modules/course-accreditation/DTO/StpSacScrutinyResultDto';
import { StpSacInspectionRegistrationReport } from 'src/app/modules/course-accreditation/models/stp-sac-inspection-registration-report.model';
import { InspectionRegistrationReport } from 'src/app/modules/course-accreditation/models/inspection-registration-report.model';
import { InspectionRegistrationRecord } from 'src/app/modules/course-accreditation/models/inspection-registration-record.model';
import { InspectionAttachment } from 'src/app/modules/course-accreditation/models/inspection-attachment.model';
import { InspectorRecommendation } from 'src/app/modules/course-accreditation/models/inspector-recommendation.model';
import { InspectionStorageService } from 'src/app/modules/course-accreditation/services/inspection-storage.service';
import { Attachment } from 'src/app/modules/course-accreditation/models/attachment';
import { ServerResponse } from 'src/app/shared/models/dto/server-response.dto';

@Component({
  selector: 'app-stp-sac-inspection-report',
  templateUrl: './stp-sac-inspection-report.component.html',
  styleUrls: ['./stp-sac-inspection-report.component.scss']
})
export class StpSacInspectionReportComponent implements OnInit {

  stpSacInspectionForm: FormGroup;
  inspectionForm: FormGroup;
  scrutinyForm: FormGroup;

  basicProfileForm: any;
  physicalInfraForm: any;
  financialDetailForm: any;
  transactionNumber: any;
  basicData: any;

  totalIncomes: number;
  totalExpenses: number;
  inspectionId: number;
  modalTabName: string;
  modalTitle: string;
  paySlip: String;

  reportId: number;
  isFileUpload = false;

  isComplete$: Subscription;
  routeSub: Subscription;

  isManualPayment = false;
  isOnlinePayment = false;
  isVisible = false;
  isVisibleForAttachment = false;
  isOkLoading = false;
  isApplicationSubmitted: boolean = false;
  isCommitte: boolean;

  response: any;

  stpSacScrutinyResult: StpSacScrutinyResultDto;
  stpTrainers: StpTrainer[] = [];
  stpOccupationTools: StpOccupationTool[] = [];
  furnitures: Furniture[] = [];
  stpManagements: StpManagement[] = [];
  recommendations: Recommendation[] = [];
  stpSacInspectionRegistrationReportList: StpSacInspectionRegistrationReport[] = [];
  inspectionRegistrationReport: InspectionRegistrationReport[] = [];
  inspectionRegistrationRecords: InspectionRegistrationRecord[] = [];
  inspectionAttachment: InspectionAttachment[] = [];
  inspectorRecomendation: InspectorRecommendation;

  isCorrectList: { id: number; name: string }[] = [
    { id: 1, name: 'Found Correct' },
    { id: 0, name: 'Not Correct' },
  ];

  scrutinyList: { id: number; name: string }[] = [
    // { id: 0, name: 'Agree with inspection result' },
    // { id: 1, name: 'Need clarification' },
    // { id: 1, name: 'Disagree with inspection result' },
  ];

  stpInformations: { name: string; modalIdentity: string }[] = [
    { name: 'Basic Profile', modalIdentity: 'basic' },
    { name: 'Physical Infrastructure Details', modalIdentity: 'Physical' },
    { name: 'Occupation Specific Trainer', modalIdentity: 'occupation' },
    { name: 'Management and Supporting Staff', modalIdentity: 'management' },
    { name: 'Financial Details', modalIdentity: 'financial' },
    {
      name: 'Tools/Equipment/Training Learning Materials',
      modalIdentity: 'tools',
    },
    { name: 'Furniture', modalIdentity: 'furniture' },
  ];

  //#region file preview and upload
  fileList: any[] = [];
  previewAttachments: Attachment[] = [];
  imageTypeArray: string[] = ['jpg', 'jpeg', 'png'];

  imageView: boolean;
  isImageLoading: boolean;
  imageURL: any;
  pdfUrl: any;
  otherPdfUrl: any;
  pdfSource = 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf';
  stpMainId: number;
  inspectionRegistrationReportId: number | null;
  isRenewed = false;
  isReapplied = false;

  @ViewChild('myInput') fileElement: ElementRef;

  saveBtnDisabled:boolean = false;

  //#endregion file preview and upload

  constructor(
    private fb: FormBuilder,
    public datepipe: DatePipe,
    private router: Router,
    private route: ActivatedRoute,
    private notification: NzNotificationService,
    private sanitizer: DomSanitizer,
    private inspectionStorageService: InspectionStorageService,
    private stpRegistrationStorageService: StpRegistrationStorageService,
    private stpRegistrationService: StpRegistrationService,
    private location: Location
  ) {
    this.inspectionStorageService.getRecommendationByType('rs').subscribe({
      next: (res) => {
        this.recommendations = res.data;
      },
    });

    this.inspectionStorageService.getRecommendationByType('s').subscribe({
      next: (res) => {
        this.scrutinyList = res.data;
      },
    });

    this.inspectionId = this.route.snapshot.params.inspectionId;
    this.onStpSacInspectionPreviewByInspectionId(this.inspectionId);

  }

  ngOnInit(): void {
    this.inspectionForm = this.fb.group({
      inspectionFormArray: this.fb.array([]),
      recommendation: this.fb.group({
        inspectorRecommendationId: [null, Validators.required],
        inspectorRemarks: [null],
        inspectionId: [this.inspectionId],
        stpMainId: [], // FIXME: Hardcode STP Main Id
        // scrutinyId: [null],
        // remarks: [null],
      }),
      files: [[]],

    });

    this.scrutinyForm = this.fb.group({
      inspectionRegistrationReportId: [], // FIXME: Hardcode inspectionRegistrationReportId
      scrutinyResultId: [null],
      scrutinyResultRemarks: [null],
      scrutinyRecommendationId: [null],
      scrutinyRecommendationRemarks: [null],
    });

    this.route.queryParams.subscribe((params) => {
      this.stpMainId = parseInt(params['stpMainId'] ?? '0');
      this.inspectionRegistrationReportId = parseInt(
        params['inspectionRegistrationReportId'] ?? '0'
      );
      this.isRenewed = params['isRenewed'] === true || params['isRenewed'] === 'true';
      this.isReapplied = params['isReapplied'] === true || params['isReapplied'] === 'true';
      this.inspectionForm
        ?.get('recommendation.stpMainId')
        ?.setValue(this.stpMainId === 0 ? null : this.stpMainId);
      this.scrutinyForm
        ?.get('inspectionRegistrationReportId')
        ?.setValue(
          this.inspectionRegistrationReportId === 0
            ? null
            : this.inspectionRegistrationReportId
        );
    });

    this.inspectorRecommendationId?.valueChanges.subscribe((value) => {
      if (value == 2) {
        this.inspectorRemarks?.setValidators([Validators.required]);
        this.inspectorRemarks?.updateValueAndValidity();
      } else {
        this.inspectorRemarks?.clearValidators();
        this.inspectorRemarks?.updateValueAndValidity();
      }
    });
  }

  get inspectionFormArray(): FormArray {
    return this.inspectionForm.get('inspectionFormArray') as FormArray;
  }

  get inspectorRecommendationId() {
    return this.inspectionForm.get('recommendation.inspectorRecommendationId');
  }

  get inspectorRemarks() {
    return this.inspectionForm.get('recommendation.inspectorRemarks');
  }

  onSelectNIDorBirthRegFile(event: any): void {
    const file = event.target.files[0];
    const target: DataTransfer = event.target as DataTransfer;
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
  }

  submitForm(): void {
    this.saveBtnDisabled = true;
    let inspectionFormData = { ...this.inspectionForm.value };
    let inspectionRecords = [...inspectionFormData.inspectionFormArray];
    if (inspectionRecords?.length > 0) {
      inspectionRecords.forEach((item: any, index: number) => {
        delete item.name;
        delete item.modalIdentity;
      });
    }

    if(this.previewAttachments.length <= 0){
      this.notification.warning('Warning', "Please upload document first !");
    }
    else {
      this.inspectionStorageService
        .saveStpAndSacRequestInspectionReport(inspectionFormData, this.fileList)
        .subscribe({
          next: (response) => {
            if (response.success) {
              this.notification.success(
                'Success!',
                'STP/ SAC registration inspection report Information saved successfully'
              );
              this.previewAttachments = response?.data?.inspectionAttachment;
              this.setPreviousAttachments();
              this.fileList = [];

              // this.router.navigate([
              //   'home/course-accreditation/complete-inspection/' +
              //     this.inspectionId,
              // ]);

              this.location.back();
            }else{
              this.notification.error(
                'Failed!',
                response.message
              );
            }
            this.saveBtnDisabled = false;
          },
          error: (error) => {
            this.notification.error('Failed', error),
            this.saveBtnDisabled = false;
          },
        });
      }

    // if (this.isFileUpload) {
    // this.inspectionStorageService
    //   .saveStpAndSacRequestInspectionReport(inspectionFormData, this.fileList)
    //   .subscribe({
    //     next: (response) => {
    //       if (response.success) {
    //         this.notification.success(
    //           'Success!',
    //           'STP/ SAC registration inspection report Information saved successfully'
    //         );
    //         this.router.navigate([
    //           'home/course-accreditation/complete-inspection/' +
    //             this.inspectionId,
    //         ]);

    //         this.previewAttachments = response.data?.inspectionAttachment;
    //         this.setPreviousAttachments();
    //         this.fileList = [];
    //       }else{
    //         this.notification.error(
    //           'Failed!',
    //           response.message
    //         );
    //       }
    //       this.saveBtnDisabled = false;
    //     },
    //     error: (error) => {
    //       this.notification.error('Failed', error),
    //       this.saveBtnDisabled = false;
    //     },
    //   });
    // }
    // else if(this.isFileUpload == false && this.previewAttachments.length>0){
    //   this.isFileUpload = true;
    //   this.inspectionStorageService
    //   .saveStpAndSacRequestInspectionReport(inspectionFormData, this.fileList)
    //   .subscribe({
    //     next: (response) => {
    //       if (response.success) {
    //         this.notification.success(
    //           'Success!',
    //           'STP/ SAC registration inspection report Information saved successfully'
    //         );
    //         this.router.navigate([
    //           'home/course-accreditation/complete-inspection/' +
    //             this.inspectionId,
    //         ]);
    //       }else{
    //         this.notification.error(
    //           'Failed!',
    //           response.message
    //         );
    //       }
    //       this.saveBtnDisabled = false;
    //     },
    //     error: (error) => {
    //       this.notification.error('Failed', error),
    //       this.saveBtnDisabled = false;
    //     },
    //   });
    // }
    // else
    // {
    //   this.notification.error(
    //     'Failed',
    //     'Please upload file and try again.'
    //   );
    //   this.saveBtnDisabled = false;
    // }
  }

  isValidFileList(): boolean {
    return !!(this.previewAttachments?.length >= 0);
  }

  submitScrutinyForm(): void {
    this.stpSacScrutinyResult = this.scrutinyForm.value;
    this.inspectionStorageService
      .saveScrutinyForStpStacInspectionReport(this.stpSacScrutinyResult)
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.notification.success(
              'Success!',
              'Scrutiny Information saved successfully'
            );
          }
        },
        error: (error) => this.notification.error('Failed', error),
      });
  }

  //#region Modal
  showModal(modalName: string, modalTitle: string = ''): void {
    this.modalTabName = modalName;
    this.modalTitle = modalTitle;
    this.isVisible = true;
  }

  handleOk(): void {
    this.isOkLoading = true;
    setTimeout(() => {
      this.isVisible = false;
      this.isOkLoading = false;
    }, 3000);
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  private getStpApplicationById() {
    this.stpRegistrationStorageService
      .readStpApplicationsForInspectionEdit(
        this.stpMainId,
        this.isReapplied,
        this.isRenewed
      )
      .subscribe(
        (res) => {
          if (res.success) {
            this.basicData = res.data;
            if (this.basicData?.stpUserInfoDto?.isCommittee === true) {
              this.isCommitte = true;
            } else {
              this.isCommitte = false;
            }
            this.basicProfileForm = {
              stpName: res.data?.stpUserInfoDto?.stpName,
              stpNameBangla: res.data?.stpUserInfoDto?.stpNameBangla,
              stpType: res.data?.stpUserInfoDto?.stpType,
              stpOwnershipType: res.data?.stpUserInfoDto?.ownershipType,
              stpMinistry: res.data?.stpUserInfoDto?.ministryName,
              stpAgency: res.data?.stpUserInfoDto?.agencyName,
              establishYear: this.datepipe.transform(
                res.data?.stpUserInfoDto?.establishYear,
                'yyyy'
              ),
              stpLocation: res.data?.stpUserInfoDto?.locationName,

              stpCountry: res.data?.stpUserInfoDto?.country,
              stpPostOffice: res.data?.stpUserInfoDto?.postOffice,
              address: res.data?.stpUserInfoDto?.address,
              contactNo: res.data?.stpUserInfoDto?.orgContact,
              email: res.data?.stpUserInfoDto?.orgEmail,
              division: res.data?.stpUserInfoDto?.division,
              district: res.data?.stpUserInfoDto?.district,
              upazilla: res.data?.stpUserInfoDto?.upazilla,

              contactName: res.data?.stpUserInfoDto?.contactName,
              contactDesignation: res.data?.stpUserInfoDto?.contactDesignation,
              contactNumber: res.data?.stpUserInfoDto?.contactNumber,
              contactEmail: res.data?.stpUserInfoDto?.contactEmail,

              isCommittee: res.data?.stpUserInfoDto?.isCommittee,
              totalMember: res.data?.stpUserInfoDto?.totalMember,
              totalFemaleMember: res.data?.stpUserInfoDto?.totalFemaleMember,
              approvalDateCommittee: this.datepipe.transform(
                res.data?.stpUserInfoDto?.approvalDate,
                'dd-MM-yyyy'
              ),
              expirationDateCommittee: this.datepipe.transform(
                res.data?.stpUserInfoDto?.expireDate,
                'dd-MM-yyyy'
              ),
              c: this.basicData?.stpUserInfoDto?.isCommittee,
            };
            this.physicalInfraForm = {
              ownershipBuilding: res.data?.stpUserInfoDto?.ownershipBuilding,
              constructionBuilding:
                res.data?.stpUserInfoDto?.constructionBuilding,
              totalArea: res.data?.stpUserInfoDto?.totalArea,
              floor: res.data?.stpUserInfoDto?.floor,
              classroom: res.data?.stpUserInfoDto?.classroom,
              classroomSize: res.data?.stpUserInfoDto?.classroomSize,
              workshop: res.data?.stpUserInfoDto?.workshop,
              workshopSize: res.data?.stpUserInfoDto?.workshopSize,
              noOfComputerLabs: res.data?.stpUserInfoDto?.noOfComputerLabs,
              sizeOfComputerLabs: res.data?.stpUserInfoDto?.sizeOfComputerLabs,
              office: res.data?.stpUserInfoDto?.office,
              trainingRoom: res.data?.stpUserInfoDto?.trainingRoom,
              washroom: res.data?.stpUserInfoDto?.washroom,
              femaleWashroom: res.data?.stpUserInfoDto?.femaleWashroom,
              isDisableFriendly: res.data?.stpUserInfoDto?.isDisableFriendly,
              isElectricity: res.data?.stpUserInfoDto?.isElectricity,
              isInternet: res.data?.stpUserInfoDto?.isInternet,
              isDrinkingWater: res.data?.stpUserInfoDto?.isDrinkingWater,
              isFireEq: res.data?.stpUserInfoDto?.isFireEq,
              isLibrary: res.data?.stpUserInfoDto?.isLibrary,
              isLightingVent: res.data?.stpUserInfoDto?.isLightingVent,
            };

            this.financialDetailForm = {
              reserveFund: parseFloat(res.data?.stpUserInfoDto?.reserveFund),
              fdr: parseFloat(res.data?.stpUserInfoDto?.fdr),
              generalFund: parseFloat(res.data?.stpUserInfoDto?.generalFund),
              availableBalanceInBankAccount: parseFloat(
                res.data?.stpUserInfoDto?.availableBalance
              ),
              accountNumber: res.data?.stpUserInfoDto?.accountNo,
              bankName: res.data?.stpUserInfoDto?.bankName,
              branchName: res.data?.stpUserInfoDto?.branchName,
              otherFunds: parseFloat(res.data?.stpUserInfoDto?.otherFund),
              remarks: res.data?.stpUserInfoDto?.remarks,
              feesFromStudents: parseFloat(
                res.data?.stpUserInfoDto?.feesFromStudent
              ),
              incomeFromOwnAssets: parseFloat(
                res.data?.stpUserInfoDto?.ownAssetIncome
              ),
              fromGovernment: parseFloat(res.data?.stpUserInfoDto?.govIncome),
              developmentCharge: parseFloat(
                res.data?.stpUserInfoDto?.developmentCharge
              ),
              admissionFee: parseFloat(res.data?.stpUserInfoDto?.admissionFee),
              examinationFee: parseFloat(res.data?.stpUserInfoDto?.examFee),
              sessionCharge: parseFloat(
                res.data?.stpUserInfoDto?.sessionCharge
              ),
              sellingOfProductsProduced: parseFloat(
                res.data?.stpUserInfoDto?.prodSell
              ),
              others_source: parseFloat(res.data?.stpUserInfoDto?.incomeOther),
              salaryOfInstructorsAndStaff: parseFloat(
                res.data?.stpUserInfoDto?.salary
              ),
              incidentalExpenses: parseFloat(
                res.data?.stpUserInfoDto?.incidental
              ),
              repairingCost: parseFloat(res.data?.stpUserInfoDto?.repairing),
              examinationExpenses: parseFloat(res.data?.stpUserInfoDto?.exam),
              travelExpenses: parseFloat(res.data?.stpUserInfoDto?.travel),
              procurementOfBooks: parseFloat(
                res.data?.stpUserInfoDto?.procBooks
              ),
              procurementOfTrainingLearningMaterials: parseFloat(
                res.data?.stpUserInfoDto?.procTraining
              ),
              procurementOfRawMaterials: parseFloat(
                res.data?.stpUserInfoDto?.procRawMat
              ),
              others_head: parseFloat(
                res.data?.stpUserInfoDto?.expenditureOthers
              ),
              totalIncomes:
                parseFloat(this.basicData.stpUserInfoDto.feesFromStudent || 0) +
                parseFloat(this.basicData.stpUserInfoDto.ownAssetIncome || 0) +
                parseFloat(this.basicData.stpUserInfoDto.govIncome || 0) +
                parseFloat(
                  this.basicData.stpUserInfoDto.developmentCharge || 0
                ) +
                parseFloat(this.basicData.stpUserInfoDto.admissionFee || 0) +
                parseFloat(this.basicData.stpUserInfoDto.examFee || 0) +
                parseFloat(this.basicData.stpUserInfoDto.sessionCharge || 0) +
                parseFloat(this.basicData.stpUserInfoDto.prodSell || 0) +
                parseFloat(this.basicData.stpUserInfoDto.incomeOther || 0),

              totalExpenses:
                parseFloat(this.basicData.stpUserInfoDto.salary || 0) +
                parseFloat(this.basicData.stpUserInfoDto.incidental || 0) +
                parseFloat(this.basicData.stpUserInfoDto.repairing || 0) +
                parseFloat(this.basicData.stpUserInfoDto.exam || 0) +
                parseFloat(this.basicData.stpUserInfoDto.travel || 0) +
                parseFloat(this.basicData.stpUserInfoDto.procBooks || 0) +
                parseFloat(this.basicData.stpUserInfoDto.procTraining || 0) +
                parseFloat(this.basicData.stpUserInfoDto.procRawMat || 0) +
                parseFloat(
                  this.basicData.stpUserInfoDto.expenditureOthers || 0
                ),
            };
            this.stpTrainers = this.basicData.stpTrainers;
            this.stpOccupationTools = this.basicData.stpTools;
            this.furnitures = this.basicData.stpFurnitures;
            this.stpManagements = this.basicData.stpStaffs;
            this.isApplicationSubmitted = this.basicData.isApplicationSubmitted;
            this.stpRegistrationService.setCheckIsCompleteRegistration(
              this.isApplicationSubmitted
            );

            this.getJsonStringFromIndex();

            this.isComplete$ = this.stpRegistrationService
              .getCheckIsCompleteRegistration()
              .subscribe((res) => {
                this.isApplicationSubmitted = res;
              });
          } else {
            this.notification.error('Failed', 'STP Application Not Found!');
          }
        },
        (error) => {
          this.notification.error('Failed', 'STP Application Not Found!');
        }
      );
  }
  //#endregion

  //#region Preview
  handleOkFile(): void {
    this.isVisibleForAttachment = false;
  }

  handleCancelFile(): void {
    this.isVisibleForAttachment = false;
  }

  // Size of the attached files (already attached + the new selection), as on the course/center report
  private getTotalSizeInBytes(newFiles: File[] = []): number {
    const existingSize = this.previewAttachments.reduce(
      (sum, f) => sum + (f.fileSize ?? 0),
      0
    );
    const newSize = newFiles.reduce((sum, f) => sum + f.size, 0);
    return existingSize + newSize;
  }

  uploadFiles(event: any) {
    if (event.target.files.length > 0) {
      let totalUploadfiles = event.target.files.length + this.previewAttachments.length
      if (totalUploadfiles > 5) {
        this.notification.error('Error', 'Can\'t upload more than 5 files');
        this.fileElement.nativeElement.value = null;
        return;
      }
      const totalSizeInMB =
        this.getTotalSizeInBytes(Array.from(event.target.files)) / (1024 * 1024);
      if (totalSizeInMB > 50) {
        this.notification.error('Error', 'Total file size must not exceed 50 MB');
        this.fileElement.nativeElement.value = null;
        return;
      }
      event.target?.files?.forEach((item: any, index: number) => {
        this.fileList.push(item);
        this.previewAttachments.push({
          fileName: item.name,
          fileObjectUrl:URL.createObjectURL(item),
          fileUrl: "",
          fileType: this.getFileTypeFromNewAttachment(item.type),
          fileIndex: this.fileList.length - 1,
          isPreviousFile: false,
          fileSize: item.size,
        });
      });
      this.fileElement.nativeElement.value = null;
      this.isFileUpload = true;
      this.saveBtnDisabled = false;
    }
  }

  getFileTypeFromNewAttachment(fileType: string) {
    let contentType = '';
    if (fileType.match(/image/)) {
      contentType = 'image';
    } else if (fileType == 'application/pdf') {
      contentType = 'pdf';
    } else {
      contentType = 'other';
    }
    return contentType;
  }

  previewAllImage(index: number, fielType: string | undefined) {
    this.imageURL = '';
    this.pdfUrl = '';
    this.otherPdfUrl = '';
    if (fielType == 'image') {
      this.isVisibleForAttachment = true;
      this.imageURL = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.previewAttachments[index].fileObjectUrl ?? ""
      );
    } else if (fielType == 'pdf') {
      this.isVisibleForAttachment = true;
      this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.previewAttachments[index].fileObjectUrl ?? ""
      );
    } else {
      const link = document.createElement('a');
      link.setAttribute('target', '_blank');
      link.setAttribute('href', (this.previewAttachments[index].fileObjectUrl ?? ""));
      link.setAttribute('download', this.previewAttachments[index].fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  }

  getExtensionFromUrl(url: string) {
    let fileType: string = '';
    let basename = url.split(/[\\/]/).pop();
    let pos = basename?.lastIndexOf('.') ?? 0;
    fileType = basename?.slice(pos + 1) ?? '';
    return fileType;
  }

  // previewImageWhenUpdating(index: number, file: Attachment) {
  //   this.imageURL = '';
  //   this.pdfUrl = '';
  //   this.otherPdfUrl = '';
  //   let basename = file.fileUrl.split(/[\\/]/).pop();
  //   let pos = basename?.lastIndexOf('.') ?? 0;
  //   let fileType = basename?.slice(pos + 1) ?? '';
  //   if (this.imageTypeArray.includes(fileType)) {
  //     this.isVisibleForAttachment = true;
  //     this.imageURL = environment.fileServiceApiUrl + file.fileUrl;
  //   } else if (fileType.trim() == 'pdf') {
  //     let fileFromUrl = this.getBase64FromUrl(
  //       environment.fileServiceApiUrl + file.fileUrl
  //     );

  //     this.isVisibleForAttachment = true;
  //   } else {
  //     this.otherPdfUrl = environment.fileServiceApiUrl + file.fileUrl;
  //     const link = document.createElement('a');
  //     link.setAttribute('target', '_blank');
  //     link.setAttribute('href', this.otherPdfUrl);
  //     link.setAttribute('download', 'doc');
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();
  //   }
  // }

  setPreviousAttachments() {
    this.previewAttachments?.forEach((item: any, index: number) => {
      let obj = { ...item };
      let fileType = this.getExtensionFromUrl(item.fileUrl);
      item.fileType = this.getFileTypeFromPreviousAttachment(fileType);
      item['isPreviousFile'] = true;
      this.setBase64AttachmentforPreviewing(index, item.fileUrl);
    });
  }

  async setBase64AttachmentforPreviewing(index: number, fileUrl: string) {
    const data = await fetch(environment.fileServiceApiUrl + fileUrl);
    if (data.status == 200) {
      const blob = await data.blob();
      this.previewAttachments[index].fileObjectUrl = URL.createObjectURL(blob);
    }
  }

  getFileTypeFromPreviousAttachment(fileUrl: string) {
    let contentType = '';
    let basename = fileUrl.split(/[\\/]/).pop();
    let pos = basename?.lastIndexOf('.') ?? 0;

    let fileType = basename?.slice(pos + 1) ?? '';
    if (this.imageTypeArray.includes(fileType)) {
      contentType = 'image';
    } else if (fileType == 'pdf') {
      contentType = 'pdf';
    } else {
      contentType = 'other';
    }
    return contentType;
  }

  async getBase64FromUrl(url: any) {
    const data = await fetch(url);

    const blob = await data.blob();
    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      URL.createObjectURL(blob)
    );
  }

  isFileTypeImageOrPdf(fileType: String): boolean {
    let isImageorPdf = false;
    if (fileType.match(/image/) || fileType == 'application/pdf') {
      isImageorPdf = true;
    } else {
      isImageorPdf = false;
    }
    return isImageorPdf;
  }

  isFileTypeImageOrPdfforPreviousImage(file: Attachment): boolean {
    let isImageorPdf = false;
    let basename = file.fileUrl.split(/[\\/]/).pop();
    let pos = basename?.lastIndexOf('.') ?? 0;
    let fileType = basename?.slice(pos + 1) ?? '';
    if (this.imageTypeArray.includes(fileType) || fileType == 'pdf') {
      isImageorPdf = true;
    } else {
      isImageorPdf = false;
    }
    return isImageorPdf;
  }

  removeAttachment(previewIndex:number, fileIndex:number | undefined):void{
    if(this.previewAttachments[previewIndex].isPreviousFile){
      this.removePreviousAttachment(previewIndex, fileIndex);
    }else{
      if (fileIndex != null) {
        this.previewAttachments.splice(previewIndex, 1);
        this.fileList.splice(fileIndex, 1);
        this.notification.success("Success!", "Attachment successfully deleted");
      }
    }

  }

  removePreviousAttachment(previewIndex: number, fileIndex: number | undefined){
    let data:fileDeleteRequest = {
       filePath: this.previewAttachments[previewIndex].fileUrl,
       inspectionResultId:  null,
       inspectionId: this.inspectionId
    }
    this.inspectionStorageService.deleteStpInspectionAttachmentReport(data)
    .subscribe((res:ServerResponse)=>{
      if(res.success){
       this.previewAttachments.splice(previewIndex, 1);
       this.notification.success("Success!", "Attachment successfully deleted");
      }else{
       this.notification.error("Error!",res.message);
      }
    })
 }
  //#endregion preview

  getExtensionFromFilename(fileName: string): string {
    let contentType = '';
    let basename = fileName.split(/[\\/]/).pop();
    let pos = basename?.lastIndexOf('.') ?? 0;
    let fileType = basename?.slice(pos + 1) ?? '';
    return fileType;
  }

  changeFileName(
    item: Attachment,
    templateRef: HTMLInputElement,
    index: number
  ) {
    let newFileName = templateRef.value;
    let fileIndex =
      item.fileIndex != null && item.fileIndex != undefined
        ? item.fileIndex
        : -1;
    if (fileIndex != -1) {
      let file = this.fileList[fileIndex];
      let extension = this.getExtensionFromFilename(file.name);
      let fileType = file.type;
      let regex1 = /[*.]?([\s]+)?/;
      let regexPattern = new RegExp(regex1.source + extension);
      newFileName = newFileName != null ? newFileName.replace(regexPattern, '') + '.' + extension : '';
      let blob = file.slice(0, file.size, fileType);
      let newFile = new File([blob], newFileName, { type: fileType });
      this.fileList[fileIndex] = newFile;
      this.previewAttachments[index].fileName = this.fileList[fileIndex].name;
      templateRef.value=  this.previewAttachments[index].fileName;
    }
  }

  getJsonStringFromIndex() {
    for (let i = 0; i < this.stpInformations.length; i++) {
      let jsonData = '';
      switch (i) {
        case 0:
          jsonData = this.basicProfileForm
            ? JSON.stringify(this.basicProfileForm)
            : '';
          this.inspectionFormArray
            .at(0)
            .get('stpHistory')
            ?.patchValue(jsonData);
          break;
        case 1:
          jsonData = this.physicalInfraForm
            ? JSON.stringify(this.physicalInfraForm)
            : '';
          this.inspectionFormArray
            .at(1)
            .get('stpHistory')
            ?.patchValue(jsonData);
          break;
        case 2:
          jsonData = this.stpTrainers ? JSON.stringify(this.stpTrainers) : '';
          this.inspectionFormArray
            .at(2)
            .get('stpHistory')
            ?.patchValue(jsonData);
          break;
        case 3:
          jsonData = this.stpManagements
            ? JSON.stringify(this.stpManagements)
            : '';
          this.inspectionFormArray
            .at(3)
            .get('stpHistory')
            ?.patchValue(jsonData);
          break;
        case 4:
          jsonData = this.financialDetailForm
            ? JSON.stringify(this.financialDetailForm)
            : '';
          this.inspectionFormArray
            .at(4)
            .get('stpHistory')
            ?.patchValue(jsonData);
          break;
        case 5:
          jsonData = this.stpOccupationTools
            ? JSON.stringify(this.stpOccupationTools)
            : '';
          this.inspectionFormArray
            .at(5)
            .get('stpHistory')
            ?.patchValue(jsonData);
          break;
        case 6:
          jsonData = this.furnitures ? JSON.stringify(this.furnitures) : '';
          this.inspectionFormArray
            .at(6)
            .get('stpHistory')
            ?.patchValue(jsonData);
          break;
      }
    }
  }

  setStpRegistrationFormGroup(): void {
    this.stpInformations.forEach(
      (item: { name: string; modalIdentity: string }, index: number) => {
        this.inspectionFormArray.push(
          this.fb.group({
            id: [null],
            name: item.name,
            title: item.name,
            modalIdentity: item.modalIdentity,
            isCorrect: [null, Validators.required],
            remarks: [null],
            stpHistory: [null],
            inspectionRegistrationReportId: [null],
          })
        );
      }
    );
  }

  setStpRegistrationFromResponseFormGroup(): void {
    this.inspectionRegistrationRecords.forEach(
      (item: InspectionRegistrationRecord, index: number) => {
        this.inspectionFormArray.push(
          this.fb.group({
            id: [item.id],
            name: [item.name],
            title: [item.title],
            modalIdentity: item.modalIdentity,
            isCorrect: [
              item.isCorrect != null ? (item.isCorrect ? 1 : 0) : null,
              Validators.required,
            ],
            remarks: [item.remarks],
            stpHistory: [item.stpHistory],
            inspectionRegistrationReportId: [this.reportId],
          })
        );
      }
    );
  }

  resetForm(): void {}

  addRemoveValidatorForRemarks(index: number) {
    let isCorrect = this.inspectionFormArray.at(index).get('isCorrect')?.value;
    if (isCorrect == 0) {
      this.inspectionFormArray
        .at(index)
        .get('remarks')
        ?.setValidators([Validators.required]);
      this.inspectionFormArray
        .at(index)
        .get('remarks')
        ?.updateValueAndValidity();
    } else {
      this.inspectionFormArray.at(index).get('remarks')?.clearValidators();
      this.inspectionFormArray
        .at(index)
        .get('remarks')
        ?.updateValueAndValidity();
    }
  }

  setDataFromPreviousSaved() {
    this.inspectionRegistrationRecords.forEach(
      (item: InspectionRegistrationRecord, index: number) => {
        switch (index) {
          case 0:
            this.basicProfileForm =
              item.stpHistory != null ? JSON.parse(item.stpHistory) : null;
            break;
          case 1:
            this.physicalInfraForm =
              item.stpHistory != null ? JSON.parse(item.stpHistory) : null;
            break;
          case 2:
            this.stpTrainers =
              item.stpHistory != null ? JSON.parse(item.stpHistory) : null;
            break;
          case 3:
            this.stpManagements =
              item.stpHistory != null ? JSON.parse(item.stpHistory) : null;
            break;
          case 4:
            this.financialDetailForm =
              item.stpHistory != null ? JSON.parse(item.stpHistory) : null;
            break;
          case 5:
            this.stpOccupationTools =
              item.stpHistory != null ? JSON.parse(item.stpHistory) : null;
            break;
          case 6:
            this.furnitures =
              item.stpHistory != null ? JSON.parse(item.stpHistory) : null;
            break;
        }
      }
    );
  }

  //#region Stp Sac Inspection Preview by inspection id
  onStpSacInspectionPreviewByInspectionId(inspectionId: number) {
    this.inspectionStorageService
      .getStpSacInspectionPreviewByInspectionId(inspectionId)
      .subscribe({
        next: (res) => {
          this.inspectionRegistrationReportId =
            res?.data?.inspectionRegistrationReport?.id;
          this.scrutinyForm
            .get('inspectionRegistrationReportId')
            ?.patchValue(this.inspectionRegistrationReportId);
          this.stpSacInspectionRegistrationReportList = res.data;
          this.inspectionRegistrationReport =
            res.data?.inspectionRegistrationReport;

          this.inspectionRegistrationRecords =
            res.data?.inspectionRegistrationReport.inspectionRegistrationRecords;

          this.inspectionRegistrationRecords?.forEach(
            (item: InspectionRegistrationRecord, index: number) => {
              item['modalIdentity'] = this.stpInformations[index].modalIdentity;
              item['name'] = this.stpInformations[index].name;
            }
          );
          this.reportId = res.data?.inspectionRegistrationReport.id;
          if (this.inspectionRegistrationRecords?.length > 0) {
            this.setStpRegistrationFromResponseFormGroup();
            this.setDataFromPreviousSaved();
          } else {
            this.setStpRegistrationFormGroup();
            this.getStpApplicationById();
          }

          this.inspectorRecomendation =
            res.data?.inspectionRegistrationReport.inspectorRecommendation;
          let recId = this.inspectorRecomendation?.id;
          this.inspectionForm
            .get('recommendation.inspectorRecommendationId')
            ?.patchValue(recId);

          let remarks = res.data?.inspectionRegistrationReport.inspectorRemarks;
          this.inspectionForm
            .get('recommendation.inspectorRemarks')
            ?.patchValue(remarks);

          this.previewAttachments =
            res?.data?.inspectionRegistrationReport?.inspectionAttachment !=
            null
              ? res?.data?.inspectionRegistrationReport?.inspectionAttachment
              : [];
          this.setPreviousAttachments();
        },
      });
  }
  //#endregion
}
